import { render, staticRenderFns } from "./riesgoReproductivo.vue?vue&type=template&id=5be96a74&"
import script from "./riesgoReproductivo.vue?vue&type=script&lang=js&"
export * from "./riesgoReproductivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports